import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessPatchResponse, PatchRequest } from '../types/JobChangeProcess';

export default function useDeleteJobChangeProcess() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      jobChangeProcessId,
      latestLogId,
      result,
      interviewed_at,
    }: PatchRequest) => {
      const response = await fetch(
        `/agent/api/job_change_processes/${jobChangeProcessId}/logs/${latestLogId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ result, interviewed_at }),
        }
      );
      const data: JobChangeProcessPatchResponse = await response.json();
      return data;
    },
  });
}
